import { action, observable } from "mobx";
import { ReleaseNotesController } from 'cd-eft/services/eftPrjAdminApi';
import { ReleaseNoteDto } from "cd-eft/_codegen_/openapi-generator/eft-prjadmin";
import { AxiosResponse } from "axios";

export class ReleaseNotesVM {

    constructor() {
    }
    @observable releaseNotes: ReleaseNoteDto[] | undefined;
    @action.bound async getReleaseNotes() {
        try {
            const response: AxiosResponse<ReleaseNoteDto[]> = await ReleaseNotesController.getTop3ByReleaseDateUsingGET();
            if (response && response.data) {
                this.releaseNotes = response.data.slice(0, 2);
            }
            // console.log('call releaseNotes');
        }
        catch (error) {
            console.error(error);
        }
    }

}